/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { MyContext } from "../../Context/MyProvider";
import { FaArrowLeftLong, FaArrowRightLong, FaPlay } from "react-icons/fa6";
import Slider from "react-slick";
import { LuCalendar1 } from "react-icons/lu";
import { MdOutlineAccessTime } from "react-icons/md";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { TbTicket, TbUsers } from "react-icons/tb";
import Loading from "../../Loading";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import mappin from "../../Images/map.png";
import mapicon from "../../Icon/map-pin.svg";
// import chaticon from '../../Icon/Vector.svg';
import profile from '../../Images/profile-default.png';
import { showTost } from "../../showTost";
import { GoPlus } from "react-icons/go";
import { IoIosRemove } from "react-icons/io";
// import Chat from "./Chat";
import { useTranslation } from "react-i18next";
import LightboxImg from "./LightBox";
import ScrollContainer from "./ScrollContainer";
import Login from "../Login&SignUp/Login";
import Signup from "../Login&SignUp/SignUp";
import { FiBell, FiHeadphones, FiMapPin, FiRefreshCcw, FiSearch, FiShield, FiStar } from "react-icons/fi";
import { HiOutlineFilm, HiOutlineHome } from "react-icons/hi2";
import { MdOutlineAccountBalanceWallet, MdOutlineApps, MdOutlineEvent, MdOutlineLocalOffer, MdOutlineShoppingBag, MdOutlineSportsCricket } from "react-icons/md";
import { BsController } from "react-icons/bs";
import { FaBriefcase, FaHeart, FaTicketAlt, FaWpforms } from "react-icons/fa";
import logoWithName from "../../Images/logowithname.png";
import DesktopUserChip from "./DesktopUserChip";
const NextArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow next" onClick={onClick}>
            <FaArrowRightLong />
        </button>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow prev" onClick={onClick}>
            <FaArrowLeftLong />
        </button>
    );
};

const EventDetails = () => {
    const { t } = useTranslation();
    const { BaseUrl, MapKey, isLoginShow, setIsLoginShow, isSignUpShow, setIsSignUpShow } = useContext(MyContext);
    const params = useParams();
    const Eventid = params.id;

    const [loading, setLoading] = useState(true);
    const [eventData, setEventData] = useState();
    const [eventArtist, setEventArtist] = useState([]);
    const [eventSponsors, setEventSponsors] = useState([]);
    const [eventFacility, setEventFacility] = useState([]);
    const [eventRestriction, setEventRestriction] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [foodMenu, setFoodMenu] = useState([]);
    const [isFavorite, setIsFavorite] = useState("");
    const [attendeesList, setAttendeesList] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [selectVideo, setSelectVideo] = useState();
    const [showTicketBox, setShowTicketBox] = useState(false);
    const [ticketList, setTicketList] = useState([]);
    const [totalPrice, setTotalPrice] = useState("0");
    const [selectTicket, setSelectTicket] = useState("");
    const [showChat, setShowChat] = useState(false);
    const [showlightbox, setShowLightBox] = useState(false);
    const [showlightbox2, setShowLightBox2] = useState(false);
    const [lightboxindex, setLightBoxIndex] = useState("");
    const [reviewdata, setReviewData] = useState([]);
    const [isEventEnded, setIsEventEnded] = useState(false);
    const [selectedArtist, setSelectedArtist] = useState(null);
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

    const Navigate = useNavigate();

    const Location = useLocation();
    const ButHidden = Location.state;

    const eventId = Eventid || sessionStorage.getItem("Eventid");
    // const Userid = localStorage.getItem("Userid");

    const zIndex = [40, 30, 20, 10, 0];

    const { event_cover_img, event_img, member_list, total_ticket, total_book_ticket } = eventData || '';

    useEffect(() => {
        document.body.classList.add("desktop-home-active");
        return () => {
            document.body.classList.remove("desktop-home-active");
        };
    }, []);

    let newdata = [];
    if (Array.isArray(event_cover_img)) {
        newdata = [event_img, ...event_cover_img];
    } else {
        newdata = [event_img];
    }

    const SportLeft = total_ticket - total_book_ticket;
    const firstFiveImages = member_list?.slice(0, 5);
    const remainingCount = member_list?.length - 5;
    const hasContent = (value) => {
        if (value === null || value === undefined) {
            return false;
        }

        return String(value)
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, " ")
            .trim().length > 0;
    };
    const visibleSponsors = eventSponsors.filter((item) => hasContent(item?.image) || hasContent(item?.name) || hasContent(item?.artist_role));
    const visibleArtists = eventArtist.filter((item) => hasContent(item?.artist_img) || hasContent(item?.artist_title) || hasContent(item?.artist_role));
    const visibleFacilities = eventFacility.filter((item) => hasContent(item?.facility_img) || hasContent(item?.facility_title));
    const visibleFoodMenu = foodMenu.filter((item) => hasContent(item?.image));
    const visibleRestrictions = eventRestriction.filter((item) => hasContent(item?.restriction_img) || hasContent(item?.restriction_title));
    const visibleGallery = gallery.filter((item) => hasContent(item));
    const visibleVideos = Array.isArray(eventData?.event_video_urls)
        ? eventData.event_video_urls.filter((item) => hasContent(item))
        : [];
    const visibleTags = Array.isArray(eventData?.event_tags)
        ? eventData.event_tags.filter((item) => hasContent(item))
        : [];
    const hasOrganizerData = hasContent(eventData?.sponsore_name) || hasContent(eventData?.sponsore_img) || hasContent(eventData?.sponsore_mobile);
    const hasAttendeesData = firstFiveImages?.filter((item) => hasContent(item)).length > 0;
    const showOrganizerSection = hasOrganizerData || hasAttendeesData;
    const hasMapData = hasContent(eventData?.event_latitude) && hasContent(eventData?.event_longtitude);
    const hasSpotsData = total_ticket !== undefined && total_book_ticket !== undefined && !Number.isNaN(SportLeft);
    const hasMainEventInfo = hasContent(eventData?.event_title)
        || hasContent(eventData?.event_sdate)
        || hasContent(eventData?.event_time_day)
        || hasContent(eventData?.event_address_title)
        || hasAttendeesData
        || hasContent(eventData?.ticket_price)
        || hasSpotsData;

    // const SlideShow = newdata.length > 4 ? 4 : newdata.length;

    // const settings = {
    //     dots: false,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: SlideShow,
    //     slidesToScroll: 1,
    //     nextArrow: <NextArrow />,
    //     prevArrow: <PrevArrow />,
    //     responsive: [
    //         { breakpoint: 1205, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
    //         { breakpoint: 995, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
    //         { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
    //     ],
    // };

    const gallerysettings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1205, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 995, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
        ],
    };

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: MapKey
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        handleHome();
        HandleGetTicket();
        axios.post(
            `${BaseUrl}user_api/joined_user.php`,
            { event_id: eventId },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
            .then((res) => {
                setAttendeesList(res?.data?.JoinedUserdata);
            })
            .catch((err) => {
                console.error('Error:');
            });
    }, [eventId]);

    // const checkEventEndTime = (eventDateStr, eventTimeString) => {
    //     if (!eventDateStr || !eventTimeString) return;

    //     try {
    //         // 🟡 STEP 1: Parse event date "21 December, 2025"
    //         const [dayPart, yearPart] = eventDateStr.split(",");
    //         const [day, monthName] = dayPart.trim().split(" ");

    //         const monthMap = {
    //             January: 0, February: 1, March: 2, April: 3,
    //             May: 4, June: 5, July: 6, August: 7,
    //             September: 8, October: 9, November: 10, December: 11
    //         };

    //         const month = monthMap[monthName];
    //         const year = parseInt(yearPart.trim(), 10);

    //         // 🟡 STEP 2: Parse end time from "Sunday,7:00 PM TO 10:00 PM"
    //         const parts = eventTimeString.split("TO");
    //         if (parts.length < 2) return;

    //         const endTimeStr = parts[1].trim(); // "10:00 PM"

    //         const [time, modifier] = endTimeStr.split(" ");
    //         let [hours, minutes] = time.split(":");

    //         hours = parseInt(hours, 10);
    //         minutes = parseInt(minutes, 10);

    //         if (modifier === "PM" && hours !== 12) hours += 12;
    //         if (modifier === "AM" && hours === 12) hours = 0;

    //         // 🟡 STEP 3: Create full event end datetime
    //         const eventEndDateTime = new Date(year, month, parseInt(day), hours, minutes, 0, 0);

    //         const now = new Date();

    //         if (now >= eventEndDateTime) {
    //             setIsEventEnded(true);
    //         } else {
    //             setIsEventEnded(false);
    //         }
    //     } catch (err) {
    //         console.error("DateTime parse error", err);
    //     }
    // };

    // useEffect(() => {
    //     if (eventData?.event_sdate && eventData?.event_time_day) {
    //         checkEventEndTime(eventData.event_sdate, eventData.event_time_day);

    //         const interval = setInterval(() => {
    //             checkEventEndTime(eventData.event_sdate, eventData.event_time_day);
    //         }, 30000);

    //         return () => clearInterval(interval);
    //     }
    // }, [eventData]);

    const handleHome = () => {
        const Userid = localStorage.getItem("Userid") || "0";
        if (Userid && eventId) {
            axios.post(
                `${BaseUrl}user_api/u_event_data.php`,
                {
                    uid: Userid,
                    event_id: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }).then((res) => {
                    if (res?.data?.ResponseCode === '200') {
                        setEventData(res.data.EventData);
                        setIsFavorite(res.data.EventData.IS_BOOKMARK)
                        setEventArtist(res.data.Event_Artist);
                        setEventSponsors(res?.data?.Event_Sponsers);
                        setEventFacility(res?.data?.Event_Facility);
                        setEventRestriction(res?.data?.Event_Restriction);
                        setGallery(res?.data?.Event_gallery);
                        setReviewData(res.data.reviewdata);
                        setFoodMenu(res.data.Event_menus);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    console.error('Error:');
                });
        }
    }

    const HandleGetTicket = () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            return axios.post(`${BaseUrl}user_api/u_event_type_price.php`, { uid: Userid, event_id: eventId })
                .then((res) => {

                    const TicketData = Array.isArray(res.data.EventTypePrice) ? res.data.EventTypePrice : [];

                    const TicketFilter = TicketData.map(ticket => ({
                        ...ticket,
                        total: 0,
                        con: 0
                    }));
                    setTicketList(TicketFilter);
                    return TicketFilter;
                })
                .catch((error) => {
                    console.error("u_event_type_price");
                    return [];
                })
        }

        return Promise.resolve([]);
    }

    const handleMap = () => {
        const googleMapsUrl = `https://www.google.com/maps?q=${eventData?.event_latitude},${eventData?.event_longtitude}`;
        window.open(googleMapsUrl, '_blank');
    };

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [loading]);

    const getThumbnailUrl = (url) => {
        const videoId = url.split("/").pop();
        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    };

    const handleFavorite = (eventId) => {

        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_fav.php`,
                {
                    uid: Userid,
                    eid: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    if (res?.data?.ResponseCode === '200') {
                        setIsFavorite(isFavorite === 0 ? 1 : 0);
                    }
                    const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
                    showTost(res?.data?.ResponseMsg, toastType);
                })
                .catch((err) => {
                    console.error('Error:');
                });
        } else {
            setIsLoginShow(true);
        }
    }

    const HandleAddTicket = (index) => {
        const updatedList = ticketList.map((ticket, i) => {
            if (i === index) {
                const newCon = ticket.con + 1;
                setTotalPrice(newCon * Number(ticket.ticket_price));
                setSelectTicket(index);
                return {
                    ...ticket,
                    con: newCon,
                    total: newCon * Number(ticket.ticket_price),
                };
            } else {
                return { ...ticket, con: 0, total: 0 };
            }
        });
        setTicketList(updatedList);
    };

    const HandleRemoveTicket = (index) => {
        const updatedList = ticketList.map((ticket, i) => {
            if (i === index) {
                const newCon = Math.max(ticket.con - 1, 0);
                setTotalPrice(newCon * Number(ticket.ticket_price));
                return {
                    ...ticket,
                    con: newCon,
                    total: newCon * Number(ticket.ticket_price),
                };
            } else {
                return ticket;
            }
        });

        setTicketList(updatedList);
    };

    const HandlePurchase = () => {
        if (Number(totalPrice) === 0) {
            showTost(t("Please select ticket !!"), "error");
            return;
        }

        const Tax = localStorage.getItem("Tax");

        const Data = {
            Eventid: eventData?.event_id,
            Eventimg: BaseUrl + eventData?.event_img,
            Eventtitle: eventData?.event_title,
            Eventdate: eventData?.event_sdate,
            Eventaddress: eventData?.event_address,
            Sponsoreid: eventData?.sponsore_id,
            Typeid: ticketList[selectTicket]?.typeid,
            Type: ticketList[selectTicket]?.ticket_type,
            con: ticketList[selectTicket]?.con,
            Singleprice: ticketList[selectTicket]?.ticket_price,
            plimit: eventData?.total_ticket,
            Totalprice: totalPrice,
            Tax: (totalPrice * Tax) / 100
        }
        sessionStorage.setItem("EventData", JSON.stringify(Data));
        document.body.style.overflow = "auto";
        Navigate("/order-summery");
    }

    const HandleBookNow = async () => {
        const Userid = localStorage.getItem("Userid");
        if (Userid) {
            setTotalPrice("0");
            setSelectTicket("");
            await HandleGetTicket();
            setShowTicketBox(true);
        } else {
            setIsLoginShow(true);
        }
    }

    useEffect(() => {
        showChat
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [showChat]);

    useEffect(() => {
        showTicketBox
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [showTicketBox]);

    const HandleNavigate = (id) => {
        Navigate("/organizer-info", { state: id });
    }

    const eventDetailMenuItems = [
        { label: "Home", icon: HiOutlineHome, path: "/" },
        { label: "Movies", icon: HiOutlineFilm },
        { label: "Events", icon: MdOutlineEvent, active: true },
        { label: "Sports", icon: MdOutlineSportsCricket },
        { label: "Games", icon: BsController },
        { label: "Shopping", icon: MdOutlineShoppingBag },
        { label: "Services", icon: MdOutlineApps },
        { label: "Offers", icon: MdOutlineLocalOffer },
        { label: "Bookings", icon: FaTicketAlt, path: "/booking" },
        { label: "Favorites", icon: FaHeart, path: "/favorite" },
        { label: "eWallet", icon: MdOutlineAccountBalanceWallet, path: "/wallet" },
        { label: "Forms", icon: FaWpforms, path: "/form-list" },
        { label: "Business", icon: FaBriefcase, path: "/business-user" },
        { label: "More", icon: MdOutlineApps },
    ];
    const eventDetailBottomMenuItems = [
        { label: "Home", icon: HiOutlineHome, path: "/" },
        { label: "Forms", icon: FaWpforms, path: "/form-list" },
        { label: "Business", icon: FaBriefcase, path: "/business-user" },
        { label: "More", icon: MdOutlineApps, action: () => setIsMobileDrawerOpen(true) },
    ];
    const handleMenuClick = (item) => {
        if (item.path) {
            Navigate(item.path);
            setIsMobileDrawerOpen(false);
        }
    };



    return (
        <div className="nabhiverse_desktop_home event_detail_layout">
            <aside className="desktop_home_sidebar">
                <div className="desktop_home_logo">
                    <img src={logoWithName} alt="Nabhiverse" />
                </div>
                <nav className="desktop_home_nav">
                    {eventDetailMenuItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.label}
                                className={`desktop_home_nav_item ${item.active ? "active" : ""}`}
                                type="button"
                                onClick={() => handleMenuClick(item)}
                            >
                                <Icon />
                                <span>{item.label}</span>
                            </button>
                        );
                    })}
                </nav>
                <div className="desktop_home_star_box">
                    <FiStar />
                    <span>nabi star</span>
                    <strong>Your Stars 620</strong>
                    <button type="button">View Benefits</button>
                </div>
                <div className="desktop_home_help_box">
                    <FiHeadphones />
                    <span>Need Help?</span>
                    <p>24x7 Support</p>
                    <button type="button">Contact Us</button>
                </div>
            </aside>

            <div
                className={`mobile_menu_overlay ${isMobileDrawerOpen ? "show" : ""}`}
                onClick={() => setIsMobileDrawerOpen(false)}
            ></div>
            <aside className={`mobile_menu_drawer ${isMobileDrawerOpen ? "show" : ""}`}>
                <div className="mobile_drawer_head">
                    <img src={logoWithName} alt="Nabhiverse" />
                    <button type="button" onClick={() => setIsMobileDrawerOpen(false)}>x</button>
                </div>
                <div className="mobile_drawer_body">
                    <nav className="mobile_drawer_nav">
                        {eventDetailMenuItems.map((item) => {
                            const Icon = item.icon;
                            return (
                                <button
                                    key={item.label}
                                    className={`desktop_home_nav_item ${item.active ? "active" : ""}`}
                                    type="button"
                                    onClick={() => handleMenuClick(item)}
                                >
                                    <Icon />
                                    <span>{item.label}</span>
                                </button>
                            );
                        })}
                    </nav>
                    <div className="desktop_home_star_box">
                        <FiStar />
                        <span>nabi star</span>
                        <strong>Your Stars 620</strong>
                        <button type="button">View Benefits</button>
                    </div>
                    <div className="desktop_home_help_box">
                        <FiHeadphones />
                        <span>Need Help?</span>
                        <p>24x7 Support</p>
                        <button type="button">Contact Us</button>
                    </div>
                </div>
            </aside>

            <main className="desktop_home_main event_detail_main">
                <header className="desktop_home_topbar event_detail_topbar">
                    <div className="mobile_header_logo">
                        <img src={logoWithName} alt="Nabhiverse" />
                    </div>
                    <div className="desktop_search_box">
                        <FiSearch />
                        <input
                            type="text"
                            placeholder="Search for apps, services, movies, events and more..."
                            readOnly
                        />
                    </div>
                    <div className="desktop_location"><FiMapPin /> Bengaluru</div>
                    <DesktopUserChip />
                    <button className="desktop_bell_btn" type="button" aria-label="Notifications">
                        <FiBell />
                        <span>3</span>
                    </button>
                </header>

            <div className="event_details">

                <div style={{ marginTop: "20px" }} className="section_1">
                    <div className="slider-container flex justify-center">
                        {/* <Slider {...settings}> */}
                        {event_cover_img ? (
                            // newdata?.map((item, index) => (
                            <div onClick={() => { setShowLightBox(true); setLightBoxIndex(0) }} key={0} className="imagewrap cursor-pointer flex justify-center w-[90%]">
                                <img style={{ width: "100%", maxWidth: "100%", borderRadius: "20px", objectFit: "cover" }} src={`${BaseUrl}${event_cover_img[0]}`} alt={`Event cover ${0}`} />
                            </div>
                            // ))
                        ) : (
                            <div className="imagewrap">
                                <img src={`${BaseUrl}${event_img}`} alt="Event cover" />
                            </div>
                        )}
                        {/* </Slider> */}
                    </div>
                </div>

                <div className="event_container">

                    {hasMainEventInfo && <div className="section_1">
                        <div style={{ justifyContent: "space-between", marginBottom: "10px" }} className="flex_box">
                            <h2 className="title">{eventData?.event_title}</h2>
                            {eventData?.event_id && <div onClick={() => handleFavorite(eventData?.event_id)} className="cursor-pointer">
                                {isFavorite === 1
                                    ? <svg fill="#fff" width="30" height="30" viewBox="0 0 16 16">
                                        <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                    </svg>
                                    : <svg fill="#fff" width="30" height="30" viewBox="0 0 16 16">
                                        <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                    </svg>}
                            </div>}
                        </div>

                        {hasContent(eventData?.event_sdate) && <div className="flex_box py-[5px]">
                            <LuCalendar1 className="text-[24px]" />
                            <p>{eventData?.event_sdate}</p>
                        </div>}

                        {hasContent(eventData?.event_time_day) && <div className="flex_box py-[5px]">
                            <MdOutlineAccessTime className="text-[24px]" />
                            <p>{eventData?.event_time_day}</p>
                        </div>}

                        {hasContent(eventData?.event_address_title) && <div className="flex_box py-[5px]">
                            <HiOutlineLocationMarker className="text-[24px]" />
                            <p onClick={handleMap} style={{ cursor: "pointer" }} className="flex_box">{eventData?.event_address_title} <img alt="map" width="30px" src={mappin} /></p>
                        </div>}

                        {hasAttendeesData && <div className="flex_box py-[5px]">
                            <TbUsers className="text-[24px]" />
                            <div onClick={() => setIsShow(true)} className="flex items-center cursor-pointer">
                                {firstFiveImages?.filter((item) => hasContent(item)).map((item, index) => (
                                    <img key={index} style={{
                                        zIndex: zIndex[index]
                                    }} src={`${BaseUrl}${item}`} className="w-[30px] h-[30px] -ms-[5px]" alt="aj" />
                                ))}
                                {member_list?.length > 5 && (
                                    <div className="remaind">
                                        <p>+{remainingCount}</p>
                                    </div>
                                )}
                            </div>
                        </div>}

                        {hasContent(eventData?.ticket_price) && <div className="flex_box py-[5px]">
                            <TbTicket className="text-[24px]" />
                            <p>{t("Ticket Price")} : {eventData?.ticket_price}</p>
                        </div>}

                        {hasSpotsData && <div className="py-[10px]">
                            <p className="text-red-500 font-bold">{SportLeft} {t("spots left")}</p>
                        </div>}

                    </div>}

                    {showOrganizerSection && <div className="section_2">
                        {hasOrganizerData && <div className="">
                            <h className="font-bold">{t("Organized By")}</h>
                            <div style={{ marginTop: "10px" }} className="flex_box">
                                {eventData?.sponsore_img ? (
                                    <img alt="" className="w-[50px] h-[50px] rounded-[100%] object-cover" src={`${BaseUrl}${eventData?.sponsore_img}`} />
                                ) : (
                                    <img alt="" className="w-[50px] h-[50px] rounded-[100%] object-cover" src={profile} />
                                )}
                                <div onClick={() => HandleNavigate(eventData?.sponsore_id)} className="group cursor-pointer">
                                    <h4 className="font-[500] group-hover:text-[#0000ffb7]">{eventData?.sponsore_name}</h4>
                                    {eventData?.is_joined === 1 &&
                                        <span className="text-gray-400 font-[500] text-[14px] group-hover:text-[#0000ffb7]">{eventData?.sponsore_mobile}</span>
                                    }
                                </div>
                            </div>
                        </div>}

                        {hasAttendeesData && <div className="">
                            <h4 className="font-bold">{t("Attendees")}({total_book_ticket})</h4>
                            <div onClick={() => setIsShow(true)} className="flex items-center cursor-pointer mt-[10px]">
                                {firstFiveImages?.filter((item) => hasContent(item)).map((item, index) => (
                                    <img key={index} style={{
                                        zIndex: zIndex[index]
                                    }} src={`${BaseUrl}${item}`} className="w-[30px] h-[30px] -ms-[5px]" alt="aj" />
                                ))}
                                {member_list?.length > 5 && (
                                    <div className="remaind">
                                        <p>+{remainingCount}</p>
                                    </div>
                                )}
                            </div>
                        </div>}

                        {/* {(Userid && eventData?.is_joined === 1) && <div className="">
                            <h4 className="font-bold">{t("Chat")}</h4>
                            <img onClick={() => setShowChat(true)} className="mt-[10px] cursor-pointer" alt="msg" src={chaticon}></img>
                        </div>} */}

                    </div>}

                    {hasContent(eventData?.event_about) && <div className="section_3">
                        <h1 className="title">{t("About Event")}</h1>
                        <p style={{ marginTop: "10px" }} dangerouslySetInnerHTML={{ __html: eventData?.event_about }} />

                    </div>}

                    {hasContent(eventData?.event_disclaimer) && <div className="section_3">
                        <h1 className="title">{t("Disclaimer")}</h1>
                        <p style={{ marginTop: "10px" }} dangerouslySetInnerHTML={{ __html: eventData?.event_disclaimer }} />
                    </div>}

                    {visibleSponsors.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Sponsors")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {visibleSponsors?.map((item, index) => {
                                return <div key={index} className="sponsors_box">
                                    <img src={BaseUrl + item.image} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.name}</span>
                                    <span style={{ fontSize: "14px", color: "gray" }}>{item.artist_role}</span>
                                </div>
                            })}
                        </div>
                    </div>}


                    {visibleArtists.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Artist")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {visibleArtists?.map((item, index) => {
                                return <div key={index} className="artist_box" onClick={() => setSelectedArtist(item)}>
                                    <img src={BaseUrl + item.artist_img} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.artist_title}</span>
                                    <span style={{ fontSize: "14px", color: "gray" }}>{item.artist_role}</span>
                                </div>
                            })}
                        </div>
                    </div>}


                    {/* Overlay */}
                    <div
                        onClick={() => setSelectedArtist(null)}
                        style={{
                            position: "fixed",
                            inset: 0,
                            zIndex: 999,
                            background: "rgba(0,0,0,0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            opacity: selectedArtist ? 1 : 0,
                            pointerEvents: selectedArtist ? "auto" : "none",
                            transition: "opacity 0.3s ease",
                        }}
                    >
                        {/* Bottom Sheet */}
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                width: "100%",
                                maxWidth: "480px",
                                background: "#fff",
                                borderRadius: "20px",
                                padding: "0 0 40px",
                                transform: selectedArtist ? "translateY(0)" : "translateY(100%)",
                                transition: "transform 0.38s cubic-bezier(0.32,0.72,0,1)",
                            }}
                        >
                            {/* Handle bar */}
                            <div
                                style={{
                                    width: 40,
                                    height: 4,
                                    background: "#ddd",
                                    borderRadius: 2,
                                    margin: "12px auto 24px",
                                }}
                            />

                            {/* Artist Image */}
                            <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
                                <img
                                    src={BaseUrl + selectedArtist?.artist_img}
                                    alt=""
                                    style={{
                                        width: 90,
                                        height: 90,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        border: "3px solid #f0f0f0",
                                    }}
                                />
                            </div>

                            {/* Name & Role */}
                            <div style={{ textAlign: "center", padding: "0 24px" }}>
                                <p style={{ fontSize: 18, fontWeight: 600, margin: "0 0 4px", color: "#111" }}>
                                    {selectedArtist?.artist_title}
                                </p>
                                <p style={{ fontSize: 14, color: "gray", margin: "0 0 8px" }}>
                                    {selectedArtist?.artist_role}
                                </p>
                                <p style={{ fontSize: 13, color: "#3b82f6", margin: "0 0 16px" }}>
                                    {selectedArtist?.email}
                                </p>

                                {/* Divider */}
                                {selectedArtist?.description && (
                                    <div
                                        style={{
                                            borderTop: "1px solid #f0f0f0",
                                            paddingTop: 14,
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: 13, color: "#555", lineHeight: 1.6, margin: 0 }}>
                                            {selectedArtist?.description}
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* Close Button */}
                            <div style={{ padding: "20px 24px 0" }}>
                                <button
                                    onClick={() => setSelectedArtist(null)}
                                    style={{
                                        width: "100%",
                                        padding: "13px",
                                        borderRadius: 12,
                                        border: "none",
                                        background: "#b38b2e",
                                        color: "#fff",
                                        fontSize: 15,
                                        fontWeight: 500,
                                        cursor: "pointer",
                                    }}
                                >
                                    {t("Close")}
                                </button>
                            </div>
                        </div>
                    </div>




                    {visibleFacilities.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Facillity")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {visibleFacilities.map((item, index) => {
                                return <div key={index} className="artist_box">
                                    <img src={BaseUrl + item.facility_img} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.facility_title}</span>
                                </div>
                            })}
                        </div>
                    </div>}

                    {visibleFoodMenu.length >= 1 && (
                        <div className="section_4">
                            <h1 className="title">{t("Food Menus")}</h1>

                            <ScrollContainer>
                                {visibleFoodMenu
                                    .map((item, index) => (
                                        <div key={index} className="artist_box">
                                            <img src={item.image} alt={"menu"} />
                                            {/* <span style={{ fontSize: "14px" }}>
                                                {item.facility_title}
                                            </span> */}
                                        </div>
                                    ))}
                            </ScrollContainer>
                        </div>
                    )}


                    {visibleRestrictions.length >= 1 && <div className="section_4">
                        <h1 className="title">{t("Event Prohibited")}</h1>
                        <div style={{ marginTop: "10px" }} className="flex_box scroll-container">
                            {visibleRestrictions.map((item, index) => {
                                return <div key={index} className="artist_box">
                                    <img src={BaseUrl + item.restriction_img} alt="" />
                                    <span style={{ fontSize: "14px" }}>{item.restriction_title}</span>
                                </div>
                            })}
                        </div>
                    </div>}

                    {visibleGallery.length >= 1 && <div className="section_5">
                        <div className="flex_box">
                            <div className="">
                                <div className="expolor_btn">{t("Explore")}</div>
                                <h1 className="title">{t("Gllery")}</h1>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px" }} className="slider-container">
                            <Slider {...gallerysettings}>
                                {visibleGallery.map((item, index) => {
                                    return <div onClick={() => { setShowLightBox2(true); setLightBoxIndex(index) }} key={index} className="">
                                        <img src={BaseUrl + item} className="w-[100%] h-[200px] rounded-[15px] object-cover cursor-pointer" alt="" />
                                    </div>
                                })}
                            </Slider>
                        </div>
                    </div>}

                    {visibleVideos.length >= 1 && <div className="section_5">
                        <div className="flex_box">
                            <div className="">
                                <div className="expolor_btn">{t("Explore")}</div>
                                <h1 className="title">{t("Video")}</h1>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px" }} className="slider-container">
                            <Slider {...gallerysettings}>
                                {visibleVideos.map((item, index) => {
                                    return <div onClick={() => setSelectVideo(item.split("/").pop())} key={index} style={{ cursor: "pointer" }} className="video_box">
                                        <img src={getThumbnailUrl(item)} className="w-[100%] h-[200px] rounded-[15px] object-cover cursor-pointer" alt="" />
                                        <div className="icon"><FaPlay style={{ marginLeft: "3px" }} /></div>
                                    </div>
                                })}
                            </Slider>
                        </div>
                    </div>}

                    {hasMapData && <div className="section_6">
                        {isLoaded &&
                            <GoogleMap
                                center={{ lat: Number(eventData?.event_latitude), lng: Number(eventData?.event_longtitude) }}
                                zoom={17}
                            >
                                <Marker
                                    position={{
                                        lat: Number(eventData?.event_latitude),
                                        lng: Number(eventData?.event_longtitude),
                                    }}
                                    icon={{
                                        url: mapicon,
                                        scaledSize: new window.google.maps.Size(40, 40),
                                    }}
                                />
                            </GoogleMap>
                        }
                    </div>}

                    {visibleTags.length >= 1 && <div className="section_7">
                        <h1 className="title">{t("Tags")}</h1>
                        <div style={{ marginTop: "10px", flexWrap: 'wrap' }} className="flex_box">
                            {visibleTags.map((item: string, index: number) => (
                                <div key={index} className="">
                                    <span>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>}

                    {reviewdata.filter((item) => hasContent(item?.customername) || hasContent(item?.rate_text) || hasContent(item?.rate_number)).length >= 1 && <div className="section_7">
                        <h1 className="title">{t("Reviews")}</h1>
                        <div className="mt-[10px]">
                            {reviewdata.filter((item) => hasContent(item?.customername) || hasContent(item?.rate_text) || hasContent(item?.rate_number)).map((item, index) => {
                                return <div key={index} className="flex items-start justify-between border-[2px] p-[10px] rounded-[15px] mt-[10px]">
                                    <div className="flex items-start gap-[10px]">
                                        <img src={BaseUrl + item.user_img} className="w-[55px] h-[55px] border-[2px] rounded-[50px] object-cover" alt="" />
                                        <div className="">
                                            <h1 className="font-bold text-[18px]">{item.customername}</h1>
                                            <p className="text-gray-500">{item.rate_text}</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-[5px]">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFA500" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.0328 3.27141C10.8375 1.5762 13.1625 1.57619 13.9672 3.27141L15.3579 6.20118C15.6774 6.87435 16.2951 7.34094 17.0096 7.44888L20.1193 7.91869C21.9187 8.19053 22.6371 10.4895 21.3351 11.8091L19.0849 14.0896C18.5679 14.6136 18.332 15.3685 18.454 16.1084L18.9852 19.3285C19.2926 21.1918 17.4116 22.6126 15.8022 21.7329L13.0208 20.2126C12.3817 19.8633 11.6183 19.8633 10.9792 20.2126L8.19776 21.7329C6.58839 22.6126 4.70742 21.1918 5.01479 19.3286L5.54599 16.1084C5.66804 15.3685 5.43211 14.6136 4.91508 14.0896L2.66488 11.8091C1.36287 10.4895 2.08133 8.19053 3.88066 7.91869L6.99037 7.44888C7.70489 7.34094 8.32257 6.87435 8.64211 6.20118L10.0328 3.27141Z" stroke="#FFA500" stroke-width="1.5" stroke-linejoin="round" />
                                        </svg>
                                        <p>{item.rate_number}</p>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>}
                </div>

                {isShow && <div onClick={() => setIsShow(false)} style={{ alignItems: "end" }} className="bottom_model">
                    <div onClick={(e) => e.stopPropagation()} className="bottom_box">
                        <div className="attendees">
                            <span>{t("Attendees")}</span>
                            <div style={{ height: "500px" }} className="scroll-container">
                                {attendeesList.map((item, index) => (
                                    <div key={index} className="attendees_box">
                                        <img src={BaseUrl + item['user_img']} alt="" />
                                        <div style={{ lineHeight: "20px" }}>
                                            <p>{item['customername']}</p>
                                            <p>{item['Total_ticket_purchase']}x {item['Total_type']}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>}

                {selectVideo && (
                    <div onClick={() => setSelectVideo(undefined)} style={{ alignItems: "center" }} className="bottom_model">
                        <div onClick={(e) => e.stopPropagation()} className="video_box">
                            <iframe
                                width="100%"
                                height="100%"
                                src={`https://www.youtube.com/embed/${selectVideo}`}
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                )}
            </div>

                <footer className="desktop_home_footer event_detail_footer">
                    <img src={logoWithName} alt="Nabhiverse" />
                    <span><FiShield /> Fast & Secure Payments</span>
                    <span><FiRefreshCcw /> Easy Returns</span>
                    <span><FiHeadphones /> 24x7 Support</span>
                    <p>© 2026 Nabhiverse. All Rights Reserved.</p>
                </footer>
            </main>

            <nav className="mobile_bottom_menu">
                {eventDetailBottomMenuItems.map((item) => {
                    const Icon = item.icon;
                    return (
                        <button
                            key={item.label}
                            type="button"
                            className={item.active ? "active" : ""}
                            onClick={() => item.action ? item.action() : Navigate(item.path)}
                        >
                            <Icon />
                            <span>{item.label}</span>
                        </button>
                    );
                })}
            </nav>

            {showTicketBox && <div onClick={() => setShowTicketBox(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="ticket_bottom">
                    <h1 className="pt-[15px] pb-[10px] font-bold text-[18px] text-white">{t("Ticket Details")}</h1>
                    <div className="border-t-[1px] pb-[10px] border-white"></div>
                    <div className="">
                        <h1 className="font-bold text-white">{t("WHAT TICKET WOULD YOU LIKE?")}</h1>
                        <div className="h-[360px] scroll-container">
                            {ticketList.map((item, index) => {
                                return <div key={index} className="ticket_box">
                                    <div className={`box ${item.con !== 0 && "select_ticket"}`}>{item.con}</div>
                                    <div className="py-[5px] w-[85%] px-[10px]">
                                        <div className="flex items-center justify-between">
                                            <h1 className="font-[500] text-[16px] text-white">{item.ticket_type}</h1>
                                            <button onClick={() => item.remainTicket > 0 && HandleAddTicket(index)} className="text-[22px] bg-[#d2a347] rounded-full p-1"><GoPlus className="text-[#ffffff]" /></button>
                                        </div>
                                        <p className="text-[14px] text-white">{item.description}</p>
                                        {/* <span className="text-[14px] text-[red]">{item.remainTicket} {t("spots left")}</span> <br /> */}
                                        <div className="flex items-center justify-between mt-2">
                                            <span className="text-[14px] font-[500] text-white">x ₹{item.ticket_price} = ₹{item.total}</span>
                                            <button onClick={() => HandleRemoveTicket(index)} className="text-[22px] bg-[#d2a347] rounded-full p-1"><IoIosRemove className="text-[#ffffff]" /></button>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <button onClick={HandlePurchase} className="button">{t("PURCHASE")} - ₹{totalPrice}</button>
                </div>
            </div>}

            {isLoginShow && <div onClick={() => setIsLoginShow(false)} className="auth_modal_overlay flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="model md:mx-auto mx-2">
                    <Login />
                </div>
            </div>}

            {isSignUpShow && <div onClick={() => setIsSignUpShow(false)} className="auth_modal_overlay flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="model">
                    <Signup />
                </div>
            </div>}

            {loading && <Loading />}

            {/* {(ButHidden !== "Past" && SportLeft !== 0 && !isEventEnded) && <div className="fixed left-0 right-0 bottom-0 bg-white py-[10px] z-[888]">
                <div className="w-[40%] mx-auto max-_430_:w-[90%] max-_770_:w-[70%]">
                    <button onClick={HandleBookNow} style={{ marginTop: "0" }} className="button">{t("Book Now")}</button>
                </div>
            </div>} */}

            {(SportLeft !== 0 && !eventData?.is_completed) && <div className="event_detail_book_bar fixed left-0 right-0 bottom-0 bg-[#373737] pb-[65px] md:pb-[20px] pt-[20px] md:pt-[20px] z-[888]">
                <div className="w-[40%] mx-auto max-_430_:w-[90%] max-_770_:w-[70%]">
                    <button onClick={HandleBookNow} style={{ marginTop: "0" }} className="button">{t("Book Now")}</button>
                </div>
            </div>}

            {/* {showChat && <div onClick={() => setShowChat(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
                <div onClick={(e) => e.stopPropagation()} className="chat_bottom">
                    <Chat index={0} name={eventData?.sponsore_name} id={eventData?.sponsore_id} setShowChat={setShowChat} />
                </div>
            </div>} */}

            {showlightbox && <LightboxImg Images={newdata} setOpen={setShowLightBox} open={showlightbox} index={lightboxindex} />}
            {showlightbox2 && <LightboxImg Images={gallery} setOpen={setShowLightBox2} open={showlightbox2} index={lightboxindex} />}

        </div>
    )
}

export default EventDetails
/* jshint ignore:end */
